import { ParentEvent } from '@g.frame/core';
import Stage from '../Stage';
import { Vector2, Vector3 } from 'three';
import SliderComponent from '../../modules/slider/SliderComponent';
import BackgroundElement from "../../g.frame.modules/uiModule/src/uiElements/BackgroundElement";
import BodyTextElement from "../../g.frame.modules/uiModule/src/uiElements/BodyTextElement";
import ModularPopUp from "../../g.frame.modules/uiModule/src/ModularPopUp";
import HeaderTextElement from "../../g.frame.modules/uiModule/src/uiElements/HeaderTextElement";
export default class UITestLevel extends Stage {
    constructor(modulesProcessor, uiManager, environment) {
        super(modulesProcessor, uiManager, environment);
        this.modulesProcessor = modulesProcessor;
        this.uiManager = uiManager;
        this.environment = environment;
        this.slider = new SliderComponent(this.modulesProcessor);
        this.controlsPosition = {
            camera: new Vector3(8.088, 2, 10.604),
            target: new Vector3(8.03, 2, 10.53)
        };
    }
    init() {
    }
    showStartMessage() {
        const pop = {
            header: 'Welcome',
            body: 'Today we are going to focus on learning agriculture science.',
            button: 'Continue',
            type: 'hint',
        };
        this.uiManager.on('first_button_click', () => {
            this.uiManager.off('first_button_click');
            this.fire('start_level', new ParentEvent('start_level'));
        });
        this.uiManager.showWelcomePopUp(pop);
    }
    initAssets() {
        const a = new BackgroundElement();
        a.set({
            headerHeight: .3,
            size: new Vector2(5, 3)
        });
        // this.addObject(a);
        // const b = new BackgroundElement();
        // b.set({
        //     size: new Vector2(5, 3)
        // });
        // this.addObject(b);
        // @ts-ignore
        const body = new BodyTextElement(this.loader, this.uiManager.textComponentFactory);
        body.set({
            text: 'In this level you are going to identify leaves that on the wooden table and pair approraiate labels with them. Click continue button to get started.',
            window: {
                size: new Vector2(2, 1),
                scale: 1,
                pxScale: 1
            }
        });
        // @ts-ignore
        const header = new HeaderTextElement(this.loader, this.uiManager.textComponentFactory);
        header.set({
            text: 'In this level you are going to identify leaves that on the wooden table and pair approraiate labels with them. Click continue button to get started.',
            window: {
                size: new Vector2(2, 1),
                scale: 2.25,
                pxScale: 1
            }
        });
        // this.addObject(body);
        const popup = new ModularPopUp();
        popup.set({
            background: a,
            elements: [
                {
                    object: header,
                    margin: .25
                },
                {
                    object: body,
                    margin: 1.75
                }
            ]
        });
        this.addObject(popup);
    }
    startLevel() {
        this.showStartMessage();
        // this.createSlider();
    }
    createSlider() {
        this.slider.uiObject.position.set(7, 2, 9);
        this.slider.uiObject.rotation.set(0, 0.5, 0);
        this.slider.init();
        // this.slider.setOptions({min: 0, max: 100});
        this.addObject(this.slider);
    }
}
